<template>
  <div class="graph-timing-selector">
    <div
      v-for="(item, i) in items"
      :key="i"
      class="item"
      :class="{ selected: item.key === selected }"
      @click="$emit('click', item.key)"
    >
      {{ $t('dashboard.chart.timings.' + item.value) }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChartTimingSelector',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: String,
    },
  },
}
</script>

<style lang="scss">
.graph-timing-selector {
  padding-top: 0.75rem;
  padding-bottom: 1.125rem;
  overflow-x: auto;
  white-space: nowrap;

  font-size: 1rem;
  line-height: 1.5rem;
  font-family: PT Sans Caption;
  font-style: normal;
  font-weight: normal;
  color: #252525;

  .item {
    padding: 4px 12px;
    border-radius: 4px;
    margin-right: 19px;
    display: inline-block;

    &:last-child {
      margin-right: 0;
    }
    &:hover {
      background-color: #f8f8ff;
      cursor: pointer;
    }
    &.selected {
      background-color: #e0e0ea;
      &:hover {
        background-color: #d3d3db;
      }
    }
  }
}
</style>
